var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pmf-wrap" },
    [
      _c("div", { staticClass: "pmf-section" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.activeGateways.length
          ? _c(
              "div",
              { staticClass: "pmf-gateway-status-list" },
              _vm._l(_vm.activeGateways, function(gw) {
                return _c(
                  "div",
                  { key: gw.key, staticClass: "pmf-gateway-status-item" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "pmf-gw-badge",
                        class: "pmf-gw-badge--" + gw.key
                      },
                      [_vm._v(_vm._s(gw.label))]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "pmf-gateway-status-item__on dashicons dashicons-yes-alt"
                    })
                  ]
                )
              }),
              0
            )
          : _c("p", { staticClass: "pmf-notice pmf-notice--warn" }, [
              _c("span", { staticClass: "dashicons dashicons-info" }),
              _vm._v("\n      No gateways enabled. Go to\n      "),
              _c(
                "a",
                { attrs: { href: _vm.paymentSettingsUrl, target: "_blank" } },
                [_vm._v("Payment Settings")]
              ),
              _vm._v("\n      to enable a gateway.\n    ")
            ])
      ]),
      _vm._v(" "),
      _vm.activeGateways.length
        ? [
            _c(
              "div",
              { staticClass: "pmf-section" },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("p", { staticClass: "pmf-hint" }, [
                  _vm._v(
                    "Override the default label shown to customers for each gateway."
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.activeGateways, function(gw) {
                  return _c(
                    "div",
                    { key: "lbl_" + gw.key, staticClass: "pmf-label-row" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "pmf-gw-badge pmf-gw-badge--sm",
                          class: "pmf-gw-badge--" + gw.key
                        },
                        [_vm._v(_vm._s(gw.label))]
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          value: _vm.getLabel(gw.key),
                          placeholder: gw.label,
                          size: "small"
                        },
                        on: {
                          input: function($event) {
                            return _vm.setLabel(gw.key, $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pmf-section" },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("el-input", {
            attrs: {
              value: _vm.fieldSettings.description || "",
              type: "textarea",
              rows: 2,
              size: "small",
              placeholder: "Optional instructions shown above payment options…"
            },
            on: {
              input: function($event) {
                return _vm.updateField("description", $event)
              }
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pmf-section__head" }, [
      _c("span", {
        staticClass: "pmf-section__head-icon dashicons dashicons-money-alt"
      }),
      _vm._v(" "),
      _c("span", { staticClass: "pmf-section__head-label" }, [
        _vm._v("Active Gateways")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pmf-section__head" }, [
      _c("span", {
        staticClass: "pmf-section__head-icon dashicons dashicons-tag"
      }),
      _vm._v(" "),
      _c("span", { staticClass: "pmf-section__head-label" }, [
        _vm._v("Custom Labels")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pmf-section__head" }, [
      _c("span", {
        staticClass:
          "pmf-section__head-icon dashicons dashicons-editor-paragraph"
      }),
      _vm._v(" "),
      _c("span", { staticClass: "pmf-section__head-label" }, [
        _vm._v("Description")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }